export type SetupItemKey =
  | "knowledge"
  | "integrations"
  | "channels"
  | "teamMembers"
  | "mobileApps";

export type AiSetupStatusSource = {
  website?: boolean;
  text?: boolean;
  files?: boolean;
  provider?: boolean;
  wa?: boolean;
  ig?: boolean;
  fm?: boolean;
};

export type AiSetupStatus = {
  knowledgeDone: boolean;
  integrationsDone: boolean;
  channelsDone: boolean;
  teamMembersDone: boolean;
  mobileAppsDone: boolean;
  isActivationBlockedByChannel: boolean;
  completedCount: number;
  totalCount: number;
  pendingItems: SetupItemKey[];
};

type GetAiSetupStatusOptions = {
  includeExtendedSteps?: boolean;
  teamMembersDone?: boolean;
  mobileAppsDone?: boolean;
};

export const getAiSetupStatus = (
  status: AiSetupStatusSource | null | undefined,
  options: GetAiSetupStatusOptions = {},
): AiSetupStatus => {
  const {
    includeExtendedSteps = false,
    teamMembersDone = false,
    mobileAppsDone = false,
  } = options;
  const knowledgeDone = Boolean(status?.website || status?.text || status?.files);
  const integrationsDone = Boolean(status?.provider);
  const channelsDone = Boolean(status?.wa || status?.ig || status?.fm);
  const isActivationBlockedByChannel = !channelsDone;

  const pendingItems: SetupItemKey[] = [];
  if (!knowledgeDone) {
    pendingItems.push("knowledge");
  }
  if (!integrationsDone) {
    pendingItems.push("integrations");
  }
  if (!channelsDone) {
    pendingItems.push("channels");
  }
  if (includeExtendedSteps && !teamMembersDone) {
    pendingItems.push("teamMembers");
  }
  if (includeExtendedSteps && !mobileAppsDone) {
    pendingItems.push("mobileApps");
  }

  const totalCount = includeExtendedSteps ? 5 : 3;

  return {
    knowledgeDone,
    integrationsDone,
    channelsDone,
    teamMembersDone,
    mobileAppsDone,
    isActivationBlockedByChannel,
    completedCount: totalCount - pendingItems.length,
    totalCount,
    pendingItems,
  };
};
